var map = {
	"./implantbook.png": 6216,
	"./inews-AEEDC.png": 5337,
	"./inews-IDEM.png": 9140,
	"./inews-IDS.png": 3427,
	"./infodent.png": 2919,
	"./infomedix.png": 9599,
	"./tabloid.png": 3615,
	"./tabloidBg.jpg": 2434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5626;